import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { NewPageNotificationBar } from "app/pages/website-analysis/traffic-sources/search/common/NotificationBannerForNewPages";


export const NotificationBannerWrapper = styled.div`
    background-color: ${colorsPalettes.bluegrey[100]};
    padding-bottom: 24px;
    ${NewPageNotificationBar} {
        margin-bottom: 0;
    }
`;
